import React from "react"
import { JourneySomethingElseContainer } from "components/views/fle/journey/JourneySomethingElseContainer"

const JourneyReceivingCareSomethingElse = ({ history }) => (
  <JourneySomethingElseContainer
    title="Tell us about your fertility care."
    helperText="If you're comfortable sharing, be specific about the type of fertility care you're receiving."
    history={history}
  />
)

export { JourneyReceivingCareSomethingElse }
